
  <mat-toolbar>
    <a mat-icon-button [routerLink]="['/search']" aria-label="Back to search menu">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </a>
    <span>{{ 'SEARCH.PLAYER_SEARCH' | translate }}</span>
  </mat-toolbar>
  <div class="app-page">
  <button mat-stroked-button type="button" class="toggle-search-button" (click)="toggleSearchFields()">
    {{ (showSearchFields ? 'SEARCH.HIDE_SEARCH_FIELDS' : 'SEARCH.SHOW_SEARCH_FIELDS') | translate }}
  </button>

  @if (showSearchFields) {
    <form [formGroup]="searchForm" (ngSubmit)="searchPlayers()" class="search-form">
      <mat-form-field appearance="fill" class="smallinput">
        <mat-label>{{ 'GENERAL.LASTNAME' | translate }}</mat-label>
        <input matInput formControlName="LastName" placeholder="{{ 'GENERAL.LASTNAME' | translate }}" autocomplete="off">
      </mat-form-field>&nbsp;
      <mat-form-field appearance="fill" class="smallinput">
        <mat-label>{{ 'GENERAL.FIRSTNAME' | translate }}</mat-label>
        <input matInput formControlName="FirstName" placeholder="{{ 'GENERAL.FIRSTNAME' | translate }}" autocomplete="off">
      </mat-form-field>&nbsp;
      <mat-form-field appearance="fill" class="smallinput">
        <mat-label>{{ 'PLAYER.POSITION' | translate }}</mat-label>
        <mat-select formControlName="PositionIds" id="PositionIds" multiple class="smallinput">
          <mat-option value="1">{{ 'PLAYER.GOALTENDER' | translate }}</mat-option>
          <mat-option value="2">{{ 'PLAYER.DEFENDER' | translate }}</mat-option>
          <mat-option value="4">{{ 'PLAYER.FORWARD' | translate }}</mat-option>
          <mat-option value="5">{{ 'PLAYER.CENTER' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
      <br/>
      <button mat-flat-button type="submit" [disabled]="searchForm.invalid || isSearching">
        @if (isSearching) {
          <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
        }
        {{ 'SEARCH.SEARCH' | translate }}
      </button>
    </form>
  }
  <br/>
  @if (isSearching) {
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
    ></mat-progress-spinner>
  }

  <div class="players-list-container">
    @if (hasSearched && dataSource.data.length === 0) {
      <div class="empty-state">
        <mat-icon>info</mat-icon>
        <span>{{ 'SEARCH.NO_PLAYERS_FOUND' | translate }}</span>
      </div>
    }

    @if (dataSource.data.length > 0) {
      <table class="player-results-table" mat-table [dataSource]="dataSource" matSort style="margin-left: 0; width: 100%;">
        <ng-container matColumnDef="Player">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SEARCH.PLAYER' | translate }}</th>
          <td mat-cell *matCellDef="let player" style="font-size: 12px;">{{ player.LastName }}, {{ player.FirstName }}</td>
        </ng-container>

        <ng-container matColumnDef="Position">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PLAYER.POSITION' | translate }}</th>
          <td mat-cell *matCellDef="let player" style="font-size: 12px;">{{ player.PositionId | position }}</td>
        </ng-container>

        <ng-container matColumnDef="DateOfBirth">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PLAYER.DATE_OF_BIRTH' | translate }}</th>
          <td mat-cell *matCellDef="let player" style="font-size: 12px;">{{ player.DateOfBirth | date:'yyyy-MM-dd' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'GENERAL.ACTIONS' | translate }}</th>
          <td mat-cell *matCellDef="let player" style="font-size: 12px; white-space: nowrap;">
            <button mat-icon-button (click)="goToPlayerDetails(player.LifelineScoutingId)" matTooltip="{{ 'SEARCH.VIEW_PLAYER_DETAILS' | translate }}" aria-label="View player details">
              <mat-icon style="font-size: 24px; opacity: 0.6;">account_box</mat-icon>
            </button>
            <button mat-icon-button (click)="createNewReport(player.LifelineScoutingId)" matTooltip="{{ 'SEARCH.CREATE_NEW_REPORT' | translate }}" aria-label="Create new report">
              <mat-icon style="font-size: 24px; opacity: 0.6;">add_circle</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 30px; font-size: 12px;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons matSort style="margin-left: 0;"></mat-paginator>
    }
  </div>
</div>

